module.exports = __webpack_public_path__ + "static/media/GE_Digital.c4f53513.png";